export enum BankruptcySearchStatus {
  PENDING = 'Pending',
  /** Accepted and waiting because PACER is down (EE-460). Runs automatically on recovery; never charged. */
  PENDING_PROVIDER = 'Pending Provider',
  COMPLETED = 'Completed',
  ERROR = 'Error'
}
